export const CAFE = {
  name: "Mehretina Cafe",
  address: "3/215 Barkly St, Footscray VIC 3011, Australia",
  addressShort: "3/215 Barkly St, Footscray",
  city: "Footscray, Melbourne",
  mapUrl: "https://www.google.com/maps/search/?api=1&query=Mehretina+Cafe+3%2F215+Barkly+St+Footscray+VIC+3011",
  hours: [
    { day: "Monday", time: "09:00 – 22:00" },
    { day: "Tuesday", time: "09:00 – 22:00" },
    { day: "Wednesday", time: "09:00 – 22:00" },
    { day: "Thursday", time: "09:00 – 22:00" },
    { day: "Friday", time: "09:00 – 22:00" },
    { day: "Saturday", time: "09:30 – 22:00" },
    { day: "Sunday", time: "10:00 – 22:00" },
  ],
  hoursNote: "Hours may vary on public holidays",
};

const IMG = {
  spris: "https://customer-assets-0z36b82j.emergentagent.net/job_mehretina-cafe/artifacts/c19tfedu_IMG_0876.jpeg",
  espresso: "https://customer-assets-0z36b82j.emergentagent.net/job_mehretina-cafe/artifacts/vvytmrjp_IMG_0877.jpeg",
  rotiJuice: "https://customer-assets-0z36b82j.emergentagent.net/job_mehretina-cafe/artifacts/zv95lek4_IMG_0878.jpeg",
  latte: "https://customer-assets-0z36b82j.emergentagent.net/job_mehretina-cafe/artifacts/vojbw447_IMG_0879.jpeg",
  owner: "https://customer-assets-0z36b82j.emergentagent.net/job_mehretina-cafe/artifacts/0zxx75a6_IMG_0880.jpeg",
  serving: "https://customer-assets-0z36b82j.emergentagent.net/job_mehretina-cafe/artifacts/tttqzs65_IMG_0881.jpeg",
  wrap: "https://customer-assets-0z36b82j.emergentagent.net/job_mehretina-cafe/artifacts/6stx0kej_IMG_0882.jpeg",
  poolRoom: "https://customer-assets-0z36b82j.emergentagent.net/job_mehretina-cafe/artifacts/ux6i0jyf_IMG_0883.jpeg",
  mural: "https://customer-assets-0z36b82j.emergentagent.net/job_mehretina-cafe/artifacts/pm6xoyi4_unnamed.webp",
  breakfast: "https://customer-assets-0z36b82j.emergentagent.net/job_mehretina-cafe/artifacts/65qbiqz9_IMG_1028.jpg",
};

export const IMAGES = IMG;

export const MENU = [
  {
    id: "espresso",
    category: "Espresso Bar",
    tagline: "Poured with a steady hand",
    items: [
      { id: "esp-espresso", name: "Espresso", desc: "A clean, syrupy shot served in a glass.", price: "4.00" },
      { id: "esp-short-long-black", name: "Short Black / Long Black", desc: "A single or double shot, poured neat.", price: "4.00" },
      { id: "esp-macchiato", name: "Macchiato", desc: "Short espresso stained with a spot of milk.", price: "4.00" },
      { id: "esp-piccolo", name: "Piccolo Latte", desc: "Ristretto in a small glass, topped with steamed milk.", price: "4.50" },
      { id: "esp-latte", name: "Latte", desc: "Double shot, silky steamed milk, a little art on top.", price: "5.00" },
      { id: "esp-cappuccino", name: "Cappuccino", desc: "Espresso, warm milk & a crown of foam.", price: "5.00" },
      { id: "esp-flat-white", name: "Flat White", desc: "Double ristretto, velvet microfoam.", price: "4.50" },
      { id: "esp-chai", name: "Chai Latte / Dirty Chai", desc: "House-spiced chai — add a shot for a dirty chai.", price: "5.50" },
    ],
  },
  {
    id: "fresh",
    category: "Fresh & Kitchen",
    tagline: "Layered juice, warm bread & bites",
    items: [
      { id: "fresh-juice", name: "Fresh Juice", desc: "Layered mango, papaya & avocado — a house favourite.", price: "8.00" },
      { id: "fresh-avocado", name: "Avocado Juice", desc: "Thick, creamy & lightly sweetened — an East African classic.", price: "7.50" },
      { id: "fresh-sambusa", name: "Sambusa", desc: "Crisp golden pastry parcels — spiced lentil or beef.", price: "4.50" },
      { id: "fresh-chapati", name: "Chapati with Honey", desc: "Warm, flaky chapati torn to share, wildflower honey & lime.", price: "6.00" },
      { id: "fresh-ambasha", name: "Ambasha", desc: "Ethiopian celebration bread, lightly spiced & subtly sweet.", price: "5.50" },
      { id: "fresh-sandwich", name: "Sandwich", desc: "Toasted sandwich, made fresh to order.", price: "9.00" },
    ],
  },
];

export const GALLERY = [
  { src: IMG.serving, label: "The Family", caption: "Home cooking, served with love" },
  { src: IMG.breakfast, label: "Traditional Breakfast", caption: "Chapati, layered juice, a squeeze of lime", clipTop: "8%" },
  { src: IMG.latte, label: "The Latte", caption: "Poured with a steady hand" },
  { src: IMG.spris, label: "Fresh Juice", caption: "Mango, papaya & avocado, layered" },
];

export const NAV_LINKS = [
  { label: "Our Story", href: "#manifesto" },
  { label: "Order", href: "#menu" },
  { label: "Gallery", href: "#gallery" },
  { label: "Visit", href: "#reserve" },
];
